import { z } from "zod";

/**
 * Runtime metadata persisted when a workflow is triggered by a dataset submission.
 * Mirrors backend `IDatasetSubmissionTriggerMetadataSchema`.
 */
export const DatasetSubmissionTriggerMetadataSchema = z.object({
  transaction_id: z.string().uuid(),
  client_id: z.string().uuid(),
  dataset_id: z.string().uuid(),
  state: z.string(),
  step: z.string(),
});

export type DatasetSubmissionTriggerMetadataType = z.infer<
  typeof DatasetSubmissionTriggerMetadataSchema
>;
